const company = state => state.company.data
const error = state => state.error
const isLoading = state => state.isLoading

const countries = state => state.countries.data
const countriesError = state => state.countriesError
const countriesIsLoading = state => state.countriesIsLoading

const cityBycountries = state => state.cityBycountries.data
const isErrcityBycountries = state => state.isErrcityBycountries
const isLoadingcityBycountries = state => state.isLoadingcityBycountries

export default {
  isLoading,
  company,
  error,
  countries,
  countriesError,
  countriesIsLoading,

  cityBycountries,
  isErrcityBycountries,
  isLoadingcityBycountries
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/company/getters.js